import Vue from 'vue'
import Router from 'vue-router'
import index from '@/home/index' //首頁

Vue.use(Router)

export default new Router({
	mode:'history',
	routes: [
		{
		path:'/',
		redirect:'/index'
		},
		{
		path:'/index',
		component:index
		},
	    
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js